import { useLayoutEffect, useEffect } from 'react';
import { isBrowser } from '../utils/index.esm.js';

var useSafeLayoutEffect = isBrowser ? useLayoutEffect : useEffect;

export { useSafeLayoutEffect };
//# sourceMappingURL=use-safe-layout-effect.esm.js.map
